define('workActivityHeartbeat',[
  'jquery',
  'underscore',
  'settings'
], function (
  $,
  _,
  Settings
) {
  'use strict';

  var TICK_MS = 60 * 1000;
  var IDLE_MS = 2 * 60 * 1000;
  var INPUT_EVENTS = 'mousemove keydown click scroll touchstart';

  var WorkActivityHeartbeat = {
    timer: null,
    lastInput: 0,
    started: false,

    start: function () {
      if (this.started) {
        return;
      }
      this.started = true;
      this.lastInput = Date.now();

      this.boundOnInput = _.bind(this.onInput, this);
      $(document).on(INPUT_EVENTS, this.boundOnInput);

      this.boundOnVisibility = _.bind(this.onVisibilityChange, this);
      document.addEventListener('visibilitychange', this.boundOnVisibility);

      this.timer = window.setInterval(_.bind(this.tick, this), TICK_MS);
      this.tick();
    },

    stop: function () {
      if (!this.started) {
        return;
      }
      this.started = false;
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
      $(document).off(INPUT_EVENTS, this.boundOnInput);
      document.removeEventListener('visibilitychange', this.boundOnVisibility);
    },

    onInput: function () {
      this.lastInput = Date.now();
    },

    onVisibilityChange: function () {
      if (!document.hidden) {
        this.lastInput = Date.now();
        this.tick();
      }
    },

    tick: function () {
      if (document.hidden) {
        return;
      }
      if (Date.now() - this.lastInput > IDLE_MS) {
        return;
      }
      var tokenId = Settings.get('tokenId');
      if (!tokenId) {
        return;
      }
      var url = Settings.url('compuzz2', 'v2/userworkactivity/heartbeat');
      $.ajax({
        type: 'POST',
        url: url,
        global: false
      });
    }
  };

  return WorkActivityHeartbeat;
});

